import React, { useState, useContext } from 'react';
import { Modal, Button, Input } from 'antd';
import { ModalBody, ModalContainer, InputLabel, Container } from './styles';
import { createCategory } from '../../utils/services/categoriesAPI';
import { DESIGN_AREA_SETTINGS_TAB } from '../../containers/SidebarMenu/translationValues';
import { useTranslation } from 'react-i18next';
// app store context API
import { AppStoreContext } from '../../context/appStoreContext';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];
const AddCategoryModal = props => {
  const { visible, onCancel, categoryType } = props;  
  const { t } = useTranslation(NAMESPACES);
  const [categoryName, setNewCategoryName] = useState('');
  const [validCategName, setValidCategName] = useState(false);
  const [savingLoader, setSavingLoader] = useState(false);
  const { updateCategoryElements, updateCategoryTemplates, userDetails } = useContext(AppStoreContext);
  const userType = userDetails.userType;

  const saveNewCategory = () => {
    setSavingLoader(true);
    let payload = {
      name: categoryName,
      type: categoryType,
    };
    createNewCategory(payload);
  };

  const createNewCategory = async payload => {
    let categoryResponse = await createCategory(payload);
    if (categoryResponse && categoryResponse.errors && categoryResponse.errors.length === 0) {
      const savedCategory = {
        createdBy: null,
        createdOn: null,
        elements: [],
        id: categoryResponse.id,
        categoryusertype: userType,
        name: payload.name,
        parentId: 0,
        status: 'active',
        type: categoryType,
        updatedBy: null,
        updatedOn: null,
      };
      if (categoryType === 'element') {
        updateCategoryElements(savedCategory, 'addNewElementCategory');
      } else {
        updateCategoryTemplates(savedCategory, 'addNewTemplateCategory');
      }
      setSavingLoader(false);
      onCancel();
    } else {
      setSavingLoader(false);
    }
  };

  const setCategoryName = categoryName => {
    setNewCategoryName(categoryName);
    setValidCategName(categoryName.split(" ").join("").length);
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={t(DESIGN_AREA_SETTINGS_TAB.ADD_NEW_CATEGORY_MODAL_TITLE.key, DESIGN_AREA_SETTINGS_TAB.ADD_NEW_CATEGORY_MODAL_TITLE.value)}
        centered
        maskClosable={false}
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            {t(DESIGN_AREA_SETTINGS_TAB.CANCEL_CREATE_NEW_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.CANCEL_CREATE_NEW_CATEGORY_BUTTON.value)}
          </Button>,
          <Button
          key="submit"
          type="primary"
          disabled={!categoryName || !validCategName}
          loading={savingLoader}
          onClick={() => saveNewCategory()}
        >
          {savingLoader
            ? t(DESIGN_AREA_SETTINGS_TAB.SAVING_NEW_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.SAVING_NEW_CATEGORY_BUTTON.value)
            : t(DESIGN_AREA_SETTINGS_TAB.SAVE_NEW_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.SAVE_NEW_CATEGORY_BUTTON.value)}
        </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <ModalContainer>
            <InputLabel>{t(DESIGN_AREA_SETTINGS_TAB.NEW_CATEGORY_NAME_LABEL.key, DESIGN_AREA_SETTINGS_TAB.NEW_CATEGORY_NAME_LABEL.value)}</InputLabel>
            <Input
              placeholder={t(DESIGN_AREA_SETTINGS_TAB.NEW_CATEGORY_PLACEHOLDER.key, DESIGN_AREA_SETTINGS_TAB.NEW_CATEGORY_PLACEHOLDER.value)}
              autoComplete="off"
              name="categoryName"
              onChange={e => setCategoryName(e.target.value)}
              size="large"
            />
          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default AddCategoryModal;
